import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';
import { Money } from '../../../../Money';
import { clear } from '../../store/actions';
import { Money as MoneyType } from '../../../../Money/types';

interface Props {
	price: MoneyType;
	hideClear?: boolean;
}

const BaggagePriceBlock: React.FC<Props> = ({ price, hideClear }) => {
	const dispatch = useDispatch();
	const { BaggagePriceBlock: css } = useTheme('UpgradeBaggageDialog');
	const { t } = useTranslation('IncludedBaggage');

	const handleClear = () => dispatch(clear());

	return (
		<div className={css.root}>
			<div className={css.price}>
				{t('Total')}: <Money money={price} roundType="ceil" />
			</div>
			{!hideClear && (
				<>
					<div className={css.delimiter} />
					<span className={css.clear} onClick={handleClear}>
						{t('Clear')}
					</span>
				</>
			)}
		</div>
	);
};

export default BaggagePriceBlock;
